import React, { Component } from "react";
import styled from 'styled-components';
import Portal from "./Portal";
import "./index.scss";

const BadgeContainer = styled.div`
  overflow: hidden;
  width: 100%;

  .badge-content {
    overflow: hidden;

    p {
        margin: 0;
        color: #252525;
    }
  }
`;

export default class LimiterBadge extends Component {
    render() {
        const { limit, isLogged } = this.props;

        if (limit == null || !limit.hasOwnProperty('used')) {
            return <></>;
        }

        return (
            <Portal>
            <BadgeContainer className="idg-limiter-badge idg-animate-me open">
                <div className="badge-content">
                    <p>
                        You have used {limit.used} out of {limit.allowed} daily searches.{' '}
                        {isLogged ? (
                            <>Your daily allowance will reset at 12 am GMT (7pm ET).</>
                        ) : (
                            <>
                                <a
                                    href={'https://tools.brightlocal.com/seo-tools/admin/login?return_to=' + window.location.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Log in
                                </a>{' '}
                                or{' '}
                                <a
                                    href="https://app.brightlocal.com/auth/sign-up/257"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    sign up for a free trial
                                </a>{' '}
                                for access to more daily searches.
                            </>
                        )}
                    </p>
                </div>
            </BadgeContainer>
            </Portal>
        );
    }
}
